import React from "react";
import { Row, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import StatsKpiCard from "./StatsKpiCard";
import { formatGnf, STATS_COLORS, barChartOptions } from "./statsChartSetup";

const StatsTabPaie = ({ data }) => {
  if (!data) return null;
  const { kpis } = data;
  const v = kpis.verrouilles;
  const o = kpis.non_verrouilles;

  const barData = {
    labels: ["Salaire net", "Gains", "Charge salariale", "Charge patronale", "CNSS employé", "CNSS patronale"],
    datasets: [
      {
        label: "Verrouillé",
        data: [
          v.salaire_net_total,
          v.total_gains,
          v.total_charge_salariale,
          v.total_charge_patronale,
          v.cnss_employe,
          v.cnss_patronale,
        ],
        backgroundColor: STATS_COLORS.success,
        borderRadius: 6,
      },
      {
        label: "Non verrouillé",
        data: [
          o.salaire_net_total,
          o.total_gains,
          o.total_charge_salariale,
          o.total_charge_patronale,
          o.cnss_employe,
          o.cnss_patronale,
        ],
        backgroundColor: STATS_COLORS.warning,
        borderRadius: 6,
      },
    ],
  };

  return (
    <div className="stats-tab-content">
      <div className="stats-alert-info mb-4">
        Comparaison directe entre salaires des périodes <strong>verrouillées</strong> (définitives)
        et <strong>non verrouillées</strong> (encore modifiables), selon vos filtres année / mois.
      </div>

      <Row className="g-3 mb-4">
        <Col md={6}>
          <div className="stats-panel stats-panel-locked">
            <h6 className="stats-panel-title">Périodes verrouillées</h6>
            <Row className="g-2">
              <Col xs={6}>
                <StatsKpiCard label="Net total" value={formatGnf(v.salaire_net_total)} unit="GNF" variant="success" />
              </Col>
              <Col xs={6}>
                <StatsKpiCard label="Lignes" value={v.nb_lignes} variant="success" sub={`${v.nb_periodes} période(s)`} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={6}>
          <div className="stats-panel stats-panel-open">
            <h6 className="stats-panel-title">Périodes non verrouillées</h6>
            <Row className="g-2">
              <Col xs={6}>
                <StatsKpiCard label="Net total" value={formatGnf(o.salaire_net_total)} unit="GNF" variant="warning" />
              </Col>
              <Col xs={6}>
                <StatsKpiCard label="Lignes" value={o.nb_lignes} variant="warning" sub={`${o.nb_periodes} période(s)`} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <div className="stats-panel">
        <h6 className="stats-panel-title">Comparatif des indicateurs</h6>
        <div className="stats-chart-box stats-chart-tall">
          <Bar
            data={barData}
            options={{
              ...barChartOptions,
              plugins: {
                ...barChartOptions.plugins,
                legend: { ...barChartOptions.plugins.legend, position: "top" },
                tooltip: {
                  ...barChartOptions.plugins.tooltip,
                  callbacks: { label: (ctx) => `${ctx.dataset.label}: ${formatGnf(ctx.raw)} GNF` },
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StatsTabPaie;
